import PendingApplicationsTemplate from "./Template";

const PendingOtApplicationsPage = () => (
    <PendingApplicationsTemplate type="OT" />
);

export default PendingOtApplicationsPage;
